/**
 * src/design-tokens.js — Single source of truth for spacing & sizing
 *
 * Components import these for styling. Tests import these for assertions.
 * Never hardcode a spacing value anywhere — use a token.
 *
 * Colors live in src/styles.js as CSS custom properties.
 * This file is for SPACING and SIZING only.
 */

export const BUTTON = {
  minHeight: 44,
  minPadding: '8px 12px',
};

export const CARD = {
  paddingX: 16,
  paddingY: 12,
  borderRadius: 12,
  stackGap: 12,
  titleGap: 4,
};

export const BREADCRUMB = {
  paddingY: 8,
  paddingX: 16,
  itemGap: 6,
  separatorMX: 4,
  fontSize: 12,
};

export const PILL = {
  paddingX: 10,
  paddingY: 4,
  gap: 6,
  fontSize: 12,
  borderRadius: 999,
};

export const INPUT = {
  minHeight: 44,
  borderRadius: 8,
  fontSize: 13,
};

export const LAYOUT = {
  screenPaddingX: 16,
  sectionGap: 24,
  listItemGap: 8,
  tabBarHeight: 64,
  headerHeight: 56,
};

export const TYPOGRAPHY = {
  titleSize: 15,
  titleWeight: 600,
  titleLineHeight: 1.3,
  titleMarginBottom: 4,
  bodySize: 13,
  bodyLineHeight: 1.5,
};
